export default {
  English: 'en',
  Farsi: 'ir',
  French: 'fr',
  Hindi: 'in',
  Nepali: 'ne',
  Portuguese: 'pt',
  Punjabi: 'pa',
  Romanian: 'ro',
  Spanish: 'es',
  Urdu: 'ur',
  Russian: 'ru',
  Telugu: 'te',
  Chinese: 'cn',
  Indonesian: 'id',
  Tamil: 'ta',
  Georgian: 'ka',
  Arabic: 'ar',
  Luganda: 'lg',
}